import * as React from 'react';
import { css } from '@emotion/css';
import { rem } from 'polished';

import { styled } from './themeContext';
import DimmedPopup from './gameNavigation/DimmedPopup';
import DevsistersGames from './gameNavigation/DevsistersGames';
import _MobileNavigationBar from './gameNavigation/MobileNavigationBar';
import { ReactComponent as _DevsistersGamesIcon } from './gameNavigation/devsisters-games.svg';
import { carouselContext, useInitNavigation } from '../carouselContext';

type MobileGameNavigationProps = {
  otherGames: readonly GatsbyTypes.DevsistersGamesGameItemFragment[],
  upcomingLabel: string,
  preLabel: string,
  currentLocale: string,
};

const TextButton = styled.button({
  padding: 0,
  color: 'rgb(174, 174, 179)',
  fontSize: '1em',
  fontFamily: 'inherit',
  textDecoration: 'none',
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
});

const DevsistersGamesButton = styled(TextButton)((props) => ({
  border: 'none',
  outline: 'none',
  cursor: 'pointer',
  padding: 0,
  background: 'transparent',
  color: '#fff',
  fontSize: rem(16),
  right: 0,
  [props.theme.media['lg']]: {
    background: 'rgb(25, 29, 36)',
    color: 'rgb(174, 174, 179)',
    fontSize: rem(16),
  },
}));

const DevsistersGamesIconWrapper = styled.div((props) => ({
  display: 'flex',
  alignItems: 'center',
  height: rem(80),
  marginLeft: rem(25),
  [props.theme.media['sm']]: {
    height: rem(100),
  },
}));

const DevsistersGamesIcon = styled(_DevsistersGamesIcon)((props) => ({
  color: '#fff',
  width: rem(140),
  height: 'auto',
  marginTop: rem(4),
  '> *': {
    fill: 'currentColor',
  },
  [props.theme.media['sm']]: {
    width: rem(200),
  },
  [props.theme.media['md']]: {
    width: rem(222),
  },
  [props.theme.media['lg']]: {
    width: rem(152),
    height: rem(16),
    marginTop: rem(4),
    '> *': {
      fill: 'currentColor',
    },
  },
}));

const MobileContainer = styled.header((props) => ({
  position: 'absolute',
  zIndex: 1,
  right: 0,
  [props.theme.media['lg']]: {
    display: 'none',
  },
}));

const MobileNavigationBar = styled(_MobileNavigationBar)((props) => ({
  [props.theme.media['lg']]: {
    display: 'none',
  },
}));

const MobileGameNavigation: React.FC<MobileGameNavigationProps> = ({
  otherGames,
  upcomingLabel,
  preLabel,
  currentLocale,
}) => {
  const { setPlayCarousel } = React.useContext(carouselContext);
  const [openGames, setOpenGames] = React.useState(false);
  const toggleGames = () => {
    setOpenGames((prevOpenGames) => !prevOpenGames);
    setPlayCarousel((prevPlayCarousel) => !prevPlayCarousel);
  };
  const hasOtherGames = otherGames.length >= 1;
  const isSupportedLanguage = !['de', 'fr'].includes(currentLocale);
  useInitNavigation(openGames, setOpenGames);
  return (
    <MobileContainer data-testid="mobile-header-top">
      <MobileNavigationBar
        transparent
        rightChildren={(hasOtherGames && isSupportedLanguage) ? (
          <>
            <DevsistersGamesButton
              onClick={toggleGames}
              data-testid="devsisters-games-button"
            >
              <DevsistersGamesIcon />
            </DevsistersGamesButton>
            <DimmedPopup
              hide={!openGames}
              onCloseButtonClick={toggleGames}
              css={css({ zIndex: 5 })}
            >
              <div>
                <DevsistersGamesIconWrapper>
                  <DevsistersGamesIcon css={{ height: rem(30) }} />
                </DevsistersGamesIconWrapper>
                <DevsistersGames onClickItem={toggleGames} otherGames={otherGames} upcomingLabel={upcomingLabel} preLabel={preLabel} />
              </div>
            </DimmedPopup>
          </>
        ) : undefined}
      />
    </MobileContainer>
  );
};

export default MobileGameNavigation;
